import { ReactNode, useEffect } from 'react';

import { FindingReconciler } from '../services/FindingReconciler';
import { useContentEditorService } from './ContentEditorServiceContext';
import { useInlineCommentManager } from './InlineCommentManagerContext';
import { useInlineEditsManager } from './InlineEditsManagerContext';

/** Keeps an {@link FindingReconciler} running for as long as this provider is mounted. */
export function FindingReconcilerProvider({ children }: { children: ReactNode }) {
  const contentEditor = useContentEditorService();
  const inlineEdits = useInlineEditsManager();
  const inlineComments = useInlineCommentManager();

  // When the services are created or replaced, then start a reconciler that listens to them.
  useEffect(() => {
    const reconciler = new FindingReconciler(contentEditor, inlineEdits, inlineComments);
    return () => reconciler.dispose();
  }, [contentEditor, inlineEdits, inlineComments]);

  return <>{children}</>;
}
